// snippets
import React from "react";

export default function TokenButton({
    label,
    className,
    children,
    onClick,
    type,
    ...remainder
}) {
    return (
        <span className="inline-flex items-center py-1 pl-2 pr-0.5 rounded-md text-xs font-light bg-gray-100 text-gray-700">
            {children ? children : label}
            <button
                type={type ? type : "button"}
                className={
                    (className ? className + " " : "") +
                    "flex-shrink-0 ml-1 mr-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center font-medium text-gray-600 hover:bg-gray-900 hover:text-white focus:outline-none focus:bg-gray-500 focus:text-white"
                }
                onClick={() => (onClick ? onClick() : null)}
                {...remainder}
            >
                <span className="sr-only">Remove</span>
                <svg
                    className="h-2 w-2"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 8 8"
                >
                    <path
                        strokeLinecap="round"
                        strokeWidth="1.5"
                        d="M1 1l6 6m0-6L1 7"
                    />
                </svg>
            </button>
        </span>
    );
}
